import { createSelector } from 'reselect';
import moment from 'moment';
import CommentsConstants from 'Shared/constants/Comments.constants';
import { Comment, CommentParentType } from 'Shared/types/Comment.type';

// TODO (josh) : this key should come from a constant
const getCommentsItems = state => state.commentsItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getGoalSlugParam = createParameterSelector(params => params.goalSlug);
const getParentTypeParam = createParameterSelector((params: { parentType: CommentParentType }) => params.parentType);
const getParentIdParam = createParameterSelector((params: { parentId: string }) => params.parentId);

const getAllComments = createSelector([getCommentsItems], comments => {
  return comments.get(CommentsConstants.State.COMMENTS_BY_SLUG);
});

export const getCommentsByGoalSlug = createSelector([getAllComments, getGoalSlugParam], (comments, slug) =>
  comments
    .filter(comment => comment.get('goalSlug') === slug)
    .sortBy(comment => moment(comment.get('createdAt')).unix())
);

const getCommentsByParentType = createSelector([getAllComments, getParentTypeParam], (comments, parentType) =>
  comments.filter(comment => comment.get('parentType') === parentType)
);

export const getCommentsByParentTypeAndParentId = createSelector(
  [getCommentsByParentType, getParentIdParam],
  (comments, parentId) =>
    (comments
      .filter(comment => comment.get('parentId') === parentId)
      .sortBy(comment => moment(comment.get('createdAt')).unix())
      .valueSeq()
      .toJS() as Comment[]) || ([] as Comment[])
);
